import axios from '@apis/spring-client';

import { SuccessResponseEmpty, UserInterestInfoRequest } from 'models/swagger-spring/data-contracts';
import { useMutation, useQueryClient } from 'react-query';

const saveUserInterestInfo = async (
  userInterestInfoRequest: UserInterestInfoRequest,
): Promise<SuccessResponseEmpty> => {
  try {
    const response = await axios.post(`/api/user/interest-info`, userInterestInfoRequest);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const useSaveUserInterestInfo = () => {
  const queryClient = useQueryClient();

  const mutate = useMutation(
    ['saveUserInterestInfo'],
    (userInterestInfoRequest: UserInterestInfoRequest) => saveUserInterestInfo(userInterestInfoRequest),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['getUserInterestInfo']);
      },
    },
  );

  return mutate;
};

export default useSaveUserInterestInfo;
